// extracted by mini-css-extract-plugin
export default {"control":"control_control__hwbmC","addIcon":"control_addIcon__tgqX5"};